import React, { useState, useEffect, useContext } from "react";
import { motion } from "framer-motion";
import { SearchContext } from "./Contexts/Context";
import { getCard } from "../service/service";

import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import pdf from "../images/collection-pdf.png";
function SajaroInformacia() {
  const [publicInfo, setPublicInfo] = useState([]);
  const [legalActs, setLegalActs] = useState([]);
  const [loading, setLoading] = useState(false);
  console.log("publicInfo", legalActs);

  const { language } = useContext(SearchContext);
  const { search } = useContext(SearchContext);

  const [news, setNews] = useState({});
  useEffect(() => {
    const link = `https://khulo.gov.ge/api/legal_acts.php`;
    fetch(link)
      .then((response) => response.json())
      .then((data) => {
        // console.log(data)
        setNews(data);
        // console.log(data)
        // console.log('news', news)

        // console.log('object keys menu', Object.keys(menu))
        // console.log('object entries აქტები', Object.entries(data).map((item,index)=> console.log(item,index)))
      });
    // console.log('news', news)
    // console.log('news 0', news[0])
  }, []);

  const actebi = async () => {
    const { content, legal_acts } = await getCard("public-information");
    setPublicInfo(content);
    setLegalActs(legal_acts);

    setLoading(true);
  };

  useEffect(() => {
    actebi();
  }, []);

  const ActsView = () => {
    return legalActs?.map((item, index) => (
      <div className="" key={index}>
        <a href={`${item.file || item.url}`} target="blank">
          <span>{item.title}</span>

          <img src={pdf} alt="" />
        </a>
      </div>
    ));
  };

  return (
    <motion.div
      intial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="sakrebulo-landing">
        <div className="landing-container">
          <div className="sajaroInfo margin-280px">
            <header>{publicInfo[0]?.title}</header>
            <Helmet>
              <title>{publicInfo[0]?.title}</title>
            </Helmet>
            <p
              className="public-info-content"
              dangerouslySetInnerHTML={{ __html: publicInfo[0]?.content }}
            />

            <ActsView />
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default SajaroInformacia;
